import type { FC } from 'react';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// TODO: https://jira.moscow.alfaintra.net/browse/ALFABANKRU-83779
// eslint-disable-next-line package-imports/no-core-components-imports
import { ConfirmationV1 as Confirmation } from '@alfalab/core-components-confirmation-v1';

import {
    selectAppMeta,
    selectSmsDocumentSign,
    documentSignSmsVerificationSetValidationError,
    documentSignSmsVerificationOverlimitRetrySms,
    documentSignSmsVerificationSendSms,
    documentSignSmsVerificationSendCode,
    resetDocumentSignSmsVerification,
} from '../../store';
import { overlimitSettings, SMS_INVALID_CODE_TEXT, smsOverlimitErrors } from '../../config';
import { getOverlimitSettings } from '../../helpers/get-overlimit-settings';
import { sendEventSmev } from '../../helpers/proxy-send-event';

import { SMS_CODE_LENGTH, SMS_SIGN_TITLE } from './config';
import { analyticsSmsDocumentSignSmev } from './analytics';

export const DocumentSignSmsVerificationDesktop: FC = () => {
    const [code, setCode] = useState('');
    const [showHint, setShowHint] = useState(false);
    const { codeChecking, codeSending, duration, isCodeValidationError, overlimitErrorType } =
        useSelector(selectSmsDocumentSign);
    const { isClientFromEsia, phone } = useSelector(selectAppMeta);
    const dispatch = useDispatch();
    const settings = getOverlimitSettings(overlimitSettings, overlimitErrorType);
    const analytics = isClientFromEsia
        ? analyticsSmsDocumentSignSmev.esia
        : analyticsSmsDocumentSignSmev.default;

    useEffect(() => {
        dispatch(documentSignSmsVerificationSendSms());

        return () => {
            // dispatch(documentSignSmsVerificationModalClose());
            dispatch(resetDocumentSignSmsVerification());
        };
    }, [dispatch]);

    useEffect(() => {
        sendEventSmev(analytics.onRenderStep);
    }, [analytics.onRenderStep]);

    useEffect(() => {
        if (overlimitErrorType === smsOverlimitErrors.overlimitRequestError) {
            sendEventSmev(analytics.onRequestErrorView);
        }
        if (overlimitErrorType === smsOverlimitErrors.overlimitResponseError) {
            sendEventSmev(analytics.onResponseErrorView);
        }
    }, [analytics.onRequestErrorView, analytics.onResponseErrorView, overlimitErrorType]);

    const handleInputChange = (params: { code: string }) => {
        if (isCodeValidationError) {
            dispatch(documentSignSmsVerificationSetValidationError(false));
        }
        setCode(params.code);
    };
    const handleInputFinished = (params: { code: string }) => {
        // Отправляем только если длина кода равна 4,
        // в остальных случаях пользователь нажал Enter не введя полностью
        // и нужно показать ошибку валидации
        if (params.code && params.code.length === SMS_CODE_LENGTH) {
            dispatch(
                documentSignSmsVerificationSendCode(params.code, {
                    onCorrectCode: analytics.smsInput.correct,
                    onIncorrectCode: analytics.smsInput.incorrect,
                })
            );
        } else {
            dispatch(documentSignSmsVerificationSetValidationError(true));
        }
    };
    const handleSmsRetryClick = () => {
        /** При открытии окна hint кликая на текст "Что если не пришло смс"
         * выставляется showHint в true, затем при закрытии окна
         * чтобы не вызывать повторно запрос смс идет проверка на был ли открыт hint
         * так как старая форма Confirmation вызывает onSmsRetryClick
         * при клике на кнопку внутри hint */
        if (showHint) {
            setShowHint(false);
        } else {
            setCode('');
            sendEventSmev(analytics.buttonRetryClick);
            dispatch(documentSignSmsVerificationSendSms());
        }
    };
    const handleOverlimitSmsRetryClick = () => {
        setCode('');
        sendEventSmev(analytics.buttonRetryClick);
        dispatch(documentSignSmsVerificationOverlimitRetrySms());
        dispatch(documentSignSmsVerificationSendSms());
    };
    const handleShowHint = () => {
        setShowHint(true);
    };

    return (
        <Confirmation
            alignContent="center"
            code={code}
            codeChecking={codeChecking}
            codeSending={codeSending}
            countdownDuration={duration}
            error={isCodeValidationError}
            errorOverlimit={
                overlimitErrorType === smsOverlimitErrors.overlimitResponseError ||
                overlimitErrorType === smsOverlimitErrors.overlimitRequestError
            }
            errorOverlimitIsFatal={overlimitErrorType === smsOverlimitErrors.overlimitRequestError}
            errorText={isCodeValidationError ? SMS_INVALID_CODE_TEXT : ''}
            hasPhoneMask={false}
            onInputChange={handleInputChange}
            onInputFinished={handleInputFinished}
            onOverlimitSmsRetryClick={handleOverlimitSmsRetryClick}
            onSmsHintLinkClick={handleShowHint}
            onSmsRetryClick={handleSmsRetryClick}
            overlimitCountdownDuration={duration}
            overlimitText={settings.text}
            overlimitTitle={settings.title}
            phone={phone}
            requiredCharAmount={SMS_CODE_LENGTH}
            signTitle={SMS_SIGN_TITLE}
        />
    );
};
